<section class="dashboard">
  <div class="dashboard-header">
    <div class="user-info">
      <img [src]="user.picture" alt="user avatar" class="avatar" />
      <div>
        <h2>{{ user.nickname }}</h2>
        <p>{{ user.email }}</p>
      </div>
    </div>
  </div>

  <div class="insights-header">
    <div class="title-group">
      <h3>Site Management</h3>
      <p>Manage your connected sites and environments</p>
    </div>
  </div>

  <div class="stats-grid">
    <div class="stat-card">
      <h3>Total Sites</h3>
      <p class="value">{{ sites.length }}</p>
    </div>
    <div class="stat-card">
      <h3>Active Sites</h3>
      <p class="value">{{ activeSiteCount }}</p>
    </div>
  </div>

  <app-admin-grid
    title="Sites"
    [entityLabel]="'Site'"
    [columns]="columns"
    [data]="sites"
    [loadLookups]="loadSiteLookups.bind(this)"
    (addClicked)="addSite()"
    (editClicked)="editSite($event)"
    (deleteClicked)="deleteSite($event)">
  </app-admin-grid>

</section>
